import { defaultColors } from "./constants";
import { defineColorCodes } from "./define-colors";
import { JBColor } from "./jb-color";
import { defineSemanticColors } from "./semantics";
import type { ColorGroupsKey, JBColorGroup, JBThemeColors, OklchParams } from "./types";
import { createColorGroup } from "./utils";
export * from './utils';
export * from "./jb-color";
export * from "./types";


export { defaultColors };

export function defineColors() {
  defineColorCodes(defaultColors);
  defineSemanticColors();
}


export type SetThemeColorParameter = {[key in ColorGroupsKey]?:JBColorGroup}
export function setColors(colors: SetThemeColorParameter) {
  function setColor(color: JBColor) {
    document.documentElement.style.setProperty(color.variableName as string, color.value);
  }
  function setColorGroup(group:JBColorGroup){
    setColor(group.main);
    setColor(group.light);
    setColor(group.dark);
    setColor(group.contrast);
    setColor(group.subtle);
    setColor(group.hover);
    setColor(group.pressed);
  }
  colors.primary && setColorGroup(colors.primary);
  colors.secondary && setColorGroup(colors.secondary);
  colors.green && setColorGroup(colors.green);
  colors.red && setColorGroup(colors.red);
  colors.yellow && setColorGroup(colors.yellow);
}

export type CreateThemeColorParameter = {[key in ColorGroupsKey]?:OklchParams}

export function createThemeColor(parameter: CreateThemeColorParameter): Partial<JBThemeColors> {
  const themeColors: Partial<JBThemeColors> = {};
  Object.keys(parameter).forEach((key: string) => {
    const baseColor = new JBColor(parameter[key as ColorGroupsKey]!, `--jb-${key}`);
    const colorGroup = createColorGroup(baseColor);
    themeColors[key as ColorGroupsKey] = colorGroup;
  });
  return themeColors;
}